import Button from "@/common/components/Button";
import SelectController from "@/common/components/SelectController";
import { Mapper } from "@/common/services/mapper";
import { useMaintenanceWorkflowValidDiagnosticEntries } from "@/features/privateCompanies/hooks/maintenance/workflows/useMaintenanceWorkflowValidDiagnosticEntries";
import { MaintenanceWorkflowValidDiagnosticEntriesTransformer } from "@/features/privateCompanies/services/maintenance/workflows/maintenanceWorkflowValidDiagnosticEntriesTransformer";
import { useFormContext, useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";
import { DirectiveDiagnosticValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { useCreateForwardingsFormStore } from "../../../../stores/createForwardingsFormStore";
import { MaintenanceForwardingsDirectiveFormStepProps } from "../../../../types/maintenanceforwardingsDirectiveFormStep.type";
import { MaintenanceForwardingsDirectiveFromSteps } from "../../../../types/maintenanceForwardingsShowDirectiveDetails.type";
import CreateForwardingDirectiveEntryFormStepAccordion from "../../../CreateForwardingDirectiveEntryFormStepAccordion";
import { filterOptions } from "@/features/users/constants/filterOptions.constant";
import { FilterOptionOption } from "react-select";
import useDebounce from "@/common/hooks/useDebounce";

const DirectiveDiagnosticFormStepPending = ({
  state,
}: MaintenanceForwardingsDirectiveFormStepProps<MaintenanceForwardingsDirectiveFromSteps.DirectiveDiagnostic>) => {
  const { workflowId } = useParams();

  const { increaseStep } = useCreateForwardingsFormStore();

  const [search, setSearch] = useDebounce('');

  const {
    control,
  } = useFormContext<DirectiveDiagnosticValidationSchema>();

  const {
    diagnostic: watchDiagnostic,
  } = useWatch({
    control,
  });

  const {
    data: diagnosticsOptions,
  } = useMaintenanceWorkflowValidDiagnosticEntries({
    workflowId,
    filters: {
      search
    },
    mapper: Mapper.mapWithTransformer({
      transformer: MaintenanceWorkflowValidDiagnosticEntriesTransformer.optionsTransformer(),
    }),
  });

  return (
    <CreateForwardingDirectiveEntryFormStepAccordion
      state={state}
      title="Prosseguir com Diagnóstico e Orçamento"
      body={(
        <div className="flex flex-col gap-4">
          <SelectController
            control={control}
            name="diagnostic"
            options={diagnosticsOptions}
            label="Diagnóstico e orçamento selecionado"
            operationKlassToCheckPermission="Admin::Maintenance::Workflows::FilterValidDiagnosticEntries"
            filterOption={filterOptions as unknown as (option: FilterOptionOption<unknown>, inputValue: string) => boolean}
            onInputChange={setSearch}
          />

          <div className="flex items-center justify-end">
            <div className="flex items-center gap-2">
              <Button
                disabled={!watchDiagnostic}
                onClick={increaseStep}
              >
                Confirmar
              </Button>
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default DirectiveDiagnosticFormStepPending;
